import React, { createContext, useContext, useState } from "react";
import { AlertColor } from "@mui/material";
import MessageAlert from "./MessageAlert";
import { setShowAlertRef } from "./MessageAlertRef";

interface AlertContextProps {
  showAlert: (type: AlertColor, message: string, duration?: number) => void;
}

const AlertContext = createContext<AlertContextProps | undefined>(undefined);

export const AlertProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const [open, setOpen] = useState(false);
  const [message, setMessage] = useState("");
  const [type, setType] = useState<AlertColor>("info");
  const [duration, setDuration] = useState(3000);

  const showAlert = (
    type: AlertColor,
    message: string,
    duration: number = 3000
  ) => {
    setType(type);
    setMessage(message);
    setDuration(duration);
    setOpen(true);
  };

  React.useEffect(() => {
    setShowAlertRef(showAlert);
  }, []);

  return (
    <AlertContext.Provider value={{ showAlert }}>
      {children}
      <MessageAlert
        open={open}
        type={type}
        message={message}
        duration={duration}
        onClose={() => setOpen(false)}
      />
    </AlertContext.Provider>
  );
};
